import {
  ParametroConciliacionBancariaService
} from "../../services/conciliacion-bancaria/parametro-conciliacion-bancaria.service";
import {Component, OnInit} from "@angular/core";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {UtilsService} from "../../../../shared/utils/utils.service";
import {DatosMaestrosService} from "../../../../services/datos-maestros.service";
import {moduloConciliacionBan} from '../../diccionarios/conciliacionBancariaModulo';
import {ConciBancaDetalla, ReporteConciBanca} from "../../models/recuadosBancario/ParamExtracionBanca";
import {RecaudoBancarioService} from "../../services/recaudoBancario/recaudo-bancario.service";
import {ExcelServiceService} from "../../../portal-compras/services/excel-service.service";

@Component({
  selector: 'app-extracto-bancario',
  templateUrl: './extracto-bancario.component.html',
  styleUrls: ['./extracto-bancario.component.css']
})
export class ExtractoBancarioComponent implements OnInit {
  formulario: FormGroup;
  result: String = '';
  result1: string = '';

  //combos
  cmbEmpresa: any[];
  cmbBanco: any[];
  // cmbCuenta: any[];

  DAT_MSG: any;
  DATA_BTNS: any;
  DAT_BTNCSS: any;

  ocultarExtractoBancario = true;

  habilitaCabec = true;
  habilitaDeta = true;

  responseValid: string;

  loading = false;
  bloquearCampo = true;
  diccionarioModulo: any;
  reporte: ReporteConciBanca | null = null;

  constructor(
    private _paramConciBanca: ParametroConciliacionBancariaService,
    private _utils: UtilsService,
    private _datosMaestros: DatosMaestrosService,
    public fb: FormBuilder,
    public excelService: ExcelServiceService,
    private _recaudoservice: RecaudoBancarioService
  ) {
    this.cargarEmpresa();
    // this.DAT_MSG = mensajes;
    // this.DATA_BTNS = buttons;
    this.diccionarioModulo = moduloConciliacionBan;
    this.DATA_BTNS = moduloConciliacionBan.button.buttonsNombre;
    this.DAT_MSG = moduloConciliacionBan.mensajes;
    this.DAT_BTNCSS = moduloConciliacionBan.button.buttonsCss;

    this.formulario = fb.group({
      idBanco: ['', [Validators.required]],
      idEmpresa: ['', [Validators.required]],
      cuenta: ['', [Validators.required]],
      fechaExtracto: ['', [Validators.required]],
      fileExtractoBancario: [null, [Validators.required]]
    });
  }

  ngOnInit() {
    this.formulario.get('fechaExtracto').setValue(this._utils.getFechaGuion());
    console.log(this.formulario.get('fechaExtracto').value);
    console.log(this._utils.getFechaGuion());
  }


  onFileChange(event: any): void {
    const selectedFile = event.target.files[0];
    this.result = 'Nombre del archivo: ' + selectedFile.name;
    this.result += '<br>Tamaño del archivo(byte): ' + selectedFile.size;
    this.result += '<br>Tipo de archivo: ' + selectedFile.type;
  }

  onFileChange1(event: any): void {
    const selectedFile = event.target.files[0];
    this.result1 = 'Nombre del archivo: ' + selectedFile.name;
    this.result1 += '<br>Tamaño del archivo(byte): ' + selectedFile.size;
    this.result1 += '<br>Tipo de archivo: ' + selectedFile.type;
  }

  cargarEmpresa() {
    // this._paramConciBanca.getAllEmpresa().subscribe((resp) => {
    this._datosMaestros.getAllEmpresas().subscribe((resp) => {
      console.log(resp);
      this.cmbEmpresa = resp;
    }, (error) => {
      this.cmbEmpresa = [];
      console.log(error);
    });
  }

  BancoEmpresa(target) {
    //this.cargarBancoEmpresa(this.formulario.get('idEmpresa').value);
    this.cargaBancoEmpresaConfigextracto(this.formulario.get('idEmpresa').value);
  }

  cargarBancoEmpresa(inIdEmpresa: string) {
    // this._paramConciBanca.getBancoPorEmpresa(inIdEmpresa).subscribe((resp) => {
    this._datosMaestros.getBancoPorEmpresa(inIdEmpresa).subscribe((resp) => {
      console.log(resp);
      this.cmbBanco = this.concatenarBancoId(resp);
    }, (error) => {
      this.cmbBanco = [];
      console.log(error);
    });
  }

  cargaBancoEmpresaConfigextracto(idEmpresa: string){
     this._recaudoservice.cargarBancoEmpresaConfigExtracto(idEmpresa).subscribe((resp) => {
       console.log(resp);
       this.cmbBanco = resp.respuesta;
     }, (error) => {
       this.cmbBanco = [];
       console.log(error);
     });
  }

  concatenarBancoId(data: any[]) {
    return data = data.map(e => {
      let newDscaBanco = e.idBanco + ' - ' + e.dscaBanco;
      delete e['dscaBanco'];
      e.dscaBanco = newDscaBanco;
      return e;
    });
  }

  cuentaBanco(target) {
    this.cargarCuentaBanco(this.formulario.get('idEmpresa').value, this.formulario.get('idBanco').value);
    //this.cargarSelectorArchivo(this.formulario.get('idEmpresa').value, this.formulario.get('idBanco').value);
  }

  cargarCuentaBanco(inIdEmpresa, inIdBanco) {
    // this._paramConciBanca.getCuentaPorBanco(inIdEmpresa, inIdBanco).subscribe((resp) => {
    this._datosMaestros.getCuentaPorBanco(inIdEmpresa, inIdBanco).subscribe((resp) => {
      this.ocultarExtractoBancario = false;
      console.log(resp);
      //this.cmbCuenta = resp;
      this.formulario.get('cuenta').setValue(resp.cuentaBancaria);
    }, (error) => {
      this.formulario.get('cuenta').setValue('');
    });
  }

  onFileSelect(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (event.target.id == 'excelInputExtractos') {
        this.formulario.get('fileExtractoBancario').setValue(file);
      }
    }
  }

  async onSubmit() {
    this.loading = true;
    const formData = new FormData();
    let data = this.formulario.value;

    formData.append('idEmpresa', this.formulario.get('idEmpresa').value);
    formData.append('idBanco', this.formulario.get('idBanco').value);
    formData.append('nCuenta', this.formulario.get('cuenta').value);
    // formData.append('file', this.formulario.get('fileCuerp').value);

    if (data.idBanco === 'IN075') {
      const file: File = this.formulario.get('fileExtractoBancario').value;
      
      const contenido: string = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = (error) => reject(error);
        reader.readAsText(file,'ISO-8859-1');
      });

      // NORMALIZAR TEXTO
      const contenidoNormalizado = this.normalizarTexto(contenido);
      console.log('Normalizo contenido');
      
      // NUEVO ARCHIVO LIMPIO
      const archivoLimpio = new Blob(
        [contenidoNormalizado],
        { type: 'text/csv;charset=utf-8' }
      );
  
      formData.append('file', archivoLimpio, file.name); 
    } else {
     formData.append('file', new Blob([this.formulario.get('fileExtractoBancario').value], {type: 'text/csv'}), data.fileExtractoBancario.name);
    }

    formData.append('fechaExtracto', this._utils.formatofecha(this.formulario.get('fechaExtracto').value));

    this._utils.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.procesar,
        text: '',
        action: this.DATA_BTNS.procesar,//'Procesar',
        loading: true,
        context: this.BancoEmpresa,
        funcion: this._paramConciBanca.cargarExtractoBancario(formData)
      }
    ).then((response: any) => {
      this.loading = false;
      console.log(response);
      this.reporte = response;
      this.formulario.reset();
    }).catch((err) => {
      this.loading = false;
    });
  }

  normalizarTexto(texto: string): string {
  return texto
    .normalize('NFD') // separa acentos
    .replace(/[\u0300-\u036f]/g, '') // elimina acentos
    .replace(/ñ/g, 'n')
    .replace(/Ñ/g, 'N')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^\x00-\x7F]/g, '');
  }

  async renderizarObjeto(data) {
    let dataEnvio: Object = {
      "idEmpresa": data.idEmpresa,
      "idBanco": data.idBanco,
      "numeroCuenta": data.cuenta,
      "fechaExtracto": this._utils.formatofecha(data.fechaExtracto)
    };
    return JSON.stringify(dataEnvio);
  }

  descargarArchivo(respuesta) {
    let name_file = respuesta.name;
    let archivo = respuesta.content;
    const dataURI = "data:aplication/plain;base64," + (archivo);
    var a = document.createElement("a");
    a.href = dataURI;
    a.setAttribute("download", name_file);
    a.click();
  }


  exportAsExcel(data: ConciBancaDetalla[] | any []){
    if(!data){
      return;
    }

    const columnas = ['Referencia', 'Fecha Extracto', 'Clave Operativa', 'Monto', 'Fecha Contable', 'Observación']
    let data1: any[] = [];

    data.forEach(fila => {
      //console.log(fila);
      data1.push( [ fila.numeroReferencia, fila.fechaExtracto, fila.claveOperativa, fila.monto, fila.fechaContable, fila.observacion] );
    });

    //console.log("dat1>",data1)

    this.excelService.exportToExcelSimpleData(columnas, data1,"RespuetaCarga");
  }

  protected readonly Object = Object;
}
